// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"cc8e4495","255":"db99e28b","286":"789d1b18","496":"682c9265","787":"96cfd066"}[chunkId] + ".chunk.js";
};